import styled from 'styled-components';
import {dFlex, alignCenter, justifyEnd} from '../../../globalVariables/GlobalFlex';
import {wrapCheckbox} from '../../checkboxFormik/CheckboxFormik.css';
import {scrollbar, mobileMedia} from '../../../globalVariables/GlobalVariables';
import {bottom} from '../../popupAfterAdvertise/privateEvent/BottomSection.css';

export const wrapper = styled.div`
    height: calc(100% - 150px);
`;
export const formContainer = styled.div`
    position: relative;
    inset-block-start: 80px;
    padding-inline: 60px;
    padding-bottom: 120px;
    ${scrollbar};

    ${mobileMedia}{
        padding-inline: 20px;
        height: calc(100% - 220px);
    }
`;

export const title = styled.div`
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 1.6px;
`;

export const checkboxContainer = styled.div`
    margin-block: 20px;
    ${dFlex};
    ${alignCenter}
    ${wrapCheckbox}{
        width: max-content; 
        gap: 10px;
    }
`;
export const buttonContainer = styled(bottom)`
    ${justifyEnd};
`;

